import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTrackPage } from '@ion/api';
import { Stack, Alert } from '@metarouter-private/mr-mui';

import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';
import RedirectFeatureGate from 'app/launch-darkly/gates/redirect-feature-gate';
import { DrawerContextProvider } from 'app/shared/contexts/drawer';

import {
  EventDebuggerTableContextProvider,
  EVENT_DEBUGGER_LOCATION_STATE_KEY,
} from './event-debugger-table/EventDebuggerTableContext';
import DebuggerDrawer from './event-debugger-table/DebuggerDrawer';
import EventDebuggerTable from './event-debugger-table';

export default function EventDebuggerPage() {
  useTrackPage('event_debugger_page_view');
  const { state } = useLocation();

  return (
    <RedirectFeatureGate flagName={FEATURE_FLAGS.eventDebuggerEcm}>
      <EventDebuggerTableContextProvider initialState={state?.[EVENT_DEBUGGER_LOCATION_STATE_KEY]}>
        <DrawerContextProvider>
          <Stack spacing={2}>
            <Alert severity="info">
              The Event Debugger displays a sample of events, not a complete record. Events absent in the debugger are
              not indicative of a data routing issue.
            </Alert>
            <EventDebuggerTable />
          </Stack>
          <DebuggerDrawer />
        </DrawerContextProvider>
      </EventDebuggerTableContextProvider>
    </RedirectFeatureGate>
  );
}
